import { Box, styled } from "@mui/material";
import { useEffect } from "react";
import colors from "../../theme/colors";
import fonts from "../../theme/fonts";
import { TEAM } from "../../types/teams";
import { PreviousRounds } from "../../types/x01";

interface PreviousScoresProps {
  previousRounds: PreviousRounds[];
  team: TEAM;
  modal?: boolean;
}

export default function PreviousScores({
  previousRounds = [],
  team,
  modal = false,
}: PreviousScoresProps) {
  const id = `${team}_scores_${modal ? "modal" : ""}`;

  useEffect(() => {
    const scrollBox = document.getElementById(id);
    if (!scrollBox) return;
    scrollBox.scrollIntoView();
  }, [previousRounds, id]);

  return (
    <Wrapper>
      {previousRounds
        .filter((pr) => pr.roundScore !== 0)
        .map(({ roundScore, startingScore }) => {
          return (
            <ScoreWrapper team={team} key={`${startingScore}_${team}`}>
              <Box>{startingScore} </Box>
              <Box>{roundScore}</Box>
            </ScoreWrapper>
          );
        })}
      <Box id={id} style={{ visibility: "hidden" }} />
    </Wrapper>
  );
}

const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  overflowY: "scroll",
  fontFamily: fonts.family.chalk,
  fontSize: fonts.size.large,
  color: colors.lightBeige,
  textDecoration: "line-through",
  textDecorationThickness: "1px",
  textDecorationSkipInk: "all",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

const ScoreWrapper = styled(Box)<{ team: TEAM }>(({ team }) => ({
  display: "flex",
  justifyContent: "space-evenly",
  flexDirection: team === TEAM.TWO ? "row-reverse" : "row",
}));
